import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Float from "../ui/Float";
import Input from "../ui/Input";
import Tabs from "../ui/Tabs";
import { CalendarIcon, CopyIcon, InfoIcon, MessageIcon } from "../utils/Icons";
import Divider from "../ui/Divider";
import { addISBNDashes, bm_date, bm_date_to_timestamp, copyToClipboard, drawNote, drawNumber, drawPC, drawPrice, drawSize, getSaved, hitTest, isISBN, istl, kbdEvent, month_labels, removeExcess, save } from "../utils/Utils";
import Cell from "../ui/Cell";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import CategorySelectorInput from "../ui/CategorySelectorInput";
import { createPopover } from "../hooks/createPopover";
import GlobalClassFile from "../popups/GlobalClassFile";
import UsedConditions, { used_conditions_data } from "../popovers/UsedConditions";
import { createModal } from "../hooks/createModal";
import Status from "../ui/Status";
import Bindings, { searchBindings } from "../popovers/Bindings";
import Conditions from "../popovers/Conditions";
import NoteIndicators from "../popovers/NoteIndicators";
import Bisacs from "../popovers/Bisacs";
import { createScreen } from "../hooks/createScreen";
import AuthorPickerScreen, { searchAuthor } from "../screens/AuthorPickerScreen";
import { VALIDATE } from "../utils/Validators";
import OSStats, { os_stats } from "../popovers/OSStats";
import { stock_structure } from "../data_structures/Stock";
import TitleLinkData from "../screens/TitlelinkData";
import Row from "../ui/Row";
import PriceField from "../ui/PriceField";
import dayjs from "dayjs";
import Spin from "../ui/Spin";
import FocusWrap from "../hooks/FocusWrap";
import ToolTip from "../ui/ToolTip";
import { getSignal } from "../App";
import CoverImage from "./CoverImage";
import DateField from "../ui/DateField";
import DateInput from "../ui/DateInput";
import { callSearch, callTitleLink } from "../popups/InventorySearch";
import { drawPicker } from "../popovers/Picker";
import SuppliersController from "../controllers/SuppliersController";



export const updateInventoryTitle = (_title = {}, _callback = () => { }) => {


    let _in_stock = (_title?.stock_id && !istl(_title));

    let _stock_data = removeExcess(
        { ...stock_structure },
        { ..._title }
    );



    _stock_data = {
        ...stock_structure,
        ..._stock_data,
    };

    if (!_stock_data.primary_code) {
        showMessage("ISBN Required");
        _callback(false, { error: "ISBN Required" });
        return;
    }

    _stock_data.publication_date = bm_date_to_timestamp(_stock_data.publication_date);
    _stock_data.receive_date = bm_date_to_timestamp(_stock_data.receive_date);

    if (!_stock_data.price) _stock_data.price = 0;
    if (!_stock_data.cost) _stock_data.cost = 0;

    _stock_data.rank = _title.rank || 0;
    _stock_data.author = (_stock_data.author || "").slice(0, 25);
    _stock_data.title = (_stock_data.title || "").slice(0, 40);

    _stock_data.original_publisher = _title?.publisher
        ? _title.publisher.slice(0, 5).toUpperCase()
        : _stock_data?.original_publisher || "";

    const _api = _in_stock ? "stock.edit" : "stock.create";

    pubCall(_api, { stock: _stock_data }, (_s, _r) => {
        _callback(_s, _r);
    });
};



export default forwardRef(function InventoryDetails(props, ref) {

    const { controller = "", cover_key = "", new_obj = "", setSelected = () => { }, grid_info = null, monthly_sold = null, in_stock = false, setData = () => { }, title_data = {}, isnew = false, edit = false, switchEdit = () => { }, updateRow = () => { }, setHistory = () => { } } = props;
    const refs = useRef([]);
    const [index, setIndex] = useState(getSaved("inventory_start_field") || "title");
    //const [index, setIndex] = useState("title");

    const signal = getSignal();
    const [viewFullImage, setViewFullImage] = useState(false);
    const session = signal?.session;

    const tempAuth = useRef("");

    const toggleCover = () => {
        setViewFullImage(true);
    };
    const editTitle = (_title, _callback = () => { }) => {
        updateInventoryTitle(_title?.title_link, (_s, _r) => {
            if (_s) {
                _callback(_r);
            } else {
                setSelected(_title);
                switchEdit()
            }
        })
    }

    useImperativeHandle(ref, () => ({
        editTitle, toggleCover
    }));


    const findField = (mouseX, mouseY) => {
        for (let i = 0; i < tabs.length; i++) {
            const _r = refs.current[tabs[i].key];
            if (tabs[i].key === "category_1" || tabs[i].key === "category_2") {
                if (hitTest(_r.element, mouseX, mouseY)) {
                    return refs.current[tabs[i].key];
                }
            }
            if (hitTest(_r, mouseX, mouseY)) {
                return refs.current[tabs[i].key];
            }
        }
        return null;
    }


    const hasPermission = (_obj = {}, _permission = "") => {

        if (_obj?.permission) {
            if (signal?.value?.session?.permission[_permission]) {
                return true;
            } else {
                return false;
            }
        }
        return true;

    }

    const tabs = [
        // { key: "primary_code", autoselect: true },
        // { key: "condition_code", autoselect: true },
        { key: "used_condition", autoselect: false },
        { key: "secondary_code", autoselect: true },
        { key: "price", autoselect: true, controlled: false },
        { key: "title", autoselect: true },
        { key: "author", autoselect: true },
        { key: "supplier_1", autoselect: true },
        { key: "supplier_2", autoselect: true },
        { key: "supplier_3", autoselect: true },
        { key: "original_publisher", autoselect: true },
        { key: "binding", autoselect: true },
        { key: "publication_date", autoselect: true },
        { key: "category_1", autoselect: true },
        { key: "category_2", autoselect: true },
        { key: "bisac", autoselect: true },
        { key: "note", autoselect: true },
        { key: "stocked_1", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_2", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_3", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_4", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_5", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_6", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_7", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_8", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_9", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_10", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_11", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_12", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_13", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "stocked_14", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "total_received", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_1", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_2", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_3", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_4", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_5", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_6", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_7", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_8", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_9", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_10", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_11", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_12", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_13", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "sold_14", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "receive_date", autoselect: true },
        { key: "total_onhand", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "minimum_onhand", autoselect: true },
        { key: "backroom", autoselect: true },
        { key: "cost", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "cost_lock", autoselect: true, permission: "edit_onhand_no_tracking" },
        { key: "out_of_stock_status", autoselect: true },
        { key: "carton_quantity", autoselect: true },
        { key: "weight", autoselect: true },
        { key: "returnable", autoselect: true },
        { key: "total_returned", autoselect: true, permission: "edit_onhand_no_tracking" },

    ].filter(item => {


        if (edit) {
            return hasPermission(item, "edit_onhand_no_tracking")
        } else {
            return true;
        }


    });

    const drawMessage = () => {
        switch (index) {
            case "primary_code": return <>EAN, UPC, ISBN (will convert to EAN), or any unique code for this product.</>;
            case "condition_code": return <>Condition code  <strong>{KBD.PAGE_UP.label}</strong> for list.</>;
            case "used_condition": return <>Used book condition, Enter by number or letter <strong>{KBD.PAGE_UP.label}</strong> for list.</>;
            case "secondary_code": return <>Optional alternate product code (UPC, EAN, or a custom number).</>;
            case "author": return <><strong>{KBD.PAGE_UP.label}</strong> to access Author list.</>;
            case "supplier_1": return <>Usual supplier. <strong>{KBD.PAGE_UP.label}</strong> to view supplier.</>;
            case "original_publisher": return <>Free-form 5 character abbreviation for the actual publisher.</>;
            case "binding": return <><strong>{KBD.PAGE_UP.label}</strong> to access master list.</>;
            case "publication_date": return <>Enter Publication date as: mmddyy yyyy yyyymm yyyymmdd </>;
            case "category_1":
            case "category_2": return <>Product category (e.g location). <strong>{KBD.PAGE_UP.label}</strong> to see classes.</>;
            case "bisac": return <>BISAC subject. <strong>{KBD.PAGE_UP.label}</strong> to access subject lists. </>;
            case "note": return <><strong>{KBD.PAGE_UP.label}</strong> to see special indicators. </>;
            case "receive_date": return <>Enter date item was first received as: mmddyy yyyy yyyymm yyyymmdd</>;
            case "minimum_onhand": return <>Minimum level to have in stock. Use Neg# to warn not to reorder.</>;
            case "backroom": return <>Qty not on sales floor.</>;
            case "cost": return <>Cost (usually automatically calculated when receiving).</>;
            case "cost_lock": return <>Use 'L' to Lock cost (i.e. Cost changes only if new stock received).</>;
            case "out_of_stock_status": return <>Status code to show on invoices when out-of-stock. <strong>{KBD.PAGE_UP.label}</strong> for list.</>
            case "weight": return <>Product weight (your choice, Lbs or Kilo).</>;
            case "carton_quantity": return <>Carton Qty.</>
            case "returnable": return <>Y/N if product may be returned to supplier.</>
            case "total_returned": return <>Total # copies returned.</>;
        }
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: (edit && tabs.find(item => item.key === index)),
        controlled: true,
        autoselect: tabs.find(item => item.key === index)?.autoselect || false,
        onChange: (e) => {
            if (index === "receive_date" || index === "publication_date") {
                return;
            }
            if (index === "note") {
                // note is an object...
                setStockData({ ...stock_data, "note": { ...stock_data.note, "full_note": e } })
            } else {
                setStockData({ ...stock_data, [index]: e })
            }

        }
    });

    const update = (index, value) => {
        setStockData({ ...stock_data, [index]: value })
    }

    const next = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();


        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const handleSaveTitle = () => {
        const oldStockId = stock_data.stock_id;

        updateInventoryTitle(stock_data, (_s, _r) => {
            if (!_s) {
                showError(_r);
                return;
            }
            showMessage("Stock updated")
            setStockData(_r);
            updateRow(_r, oldStockId);
            switchEdit(_r);
        });
    };
    // I don't remember why i was fetching initial - this breaks titlelink results, so i'm dropping for now 
    // const handleSaveTitle = () => {
    //     updateInventoryTitle(stock_data, (_s, _r) => {
    //         if (!_s) {
    //             showError(_r);
    //             return;
    //         };
    //         const _stock_data = _r;
    //         const _is_new = istl(stock_data) || !stock_data?.stock_id;

    //         if (_is_new) {
    //             pubCall("stock.getInitial", {
    //                 stock_id: _r.stock_id,
    //                 limit: 45,
    //                 sort: "id"
    //             }, (_su, _re) => {
    //                 if (!_su) {
    //                     showError(_re);
    //                     return;
    //                 }
    //                 setData(_re.rows_previous.concat(_re.rows_next));

    //                 setTimeout(() => {
    //                     setSelected(
    //                         _re.rows_next.length > 0
    //                             ? _re.rows_next[0]
    //                             : _re.rows_previous.length > 0
    //                                 ? _re.rows_previous[_re.rows_previous.length - 1]
    //                                 : {}
    //                     );
    //                     switchEdit(_r);
    //                 }, 10);
    //             });
    //             return;
    //         }


    //         setStockData(_r);
    //         updateRow(_r, _stock_data.stock_id);
    //         switchEdit(_r);
    //     });
    // };

    const handleCopy = (e) => {
        if (index === "primary_code") {
            let _primary_code = refs.current[index].value;
            let _condition = refs.current["condition_code"].value;
            let _copied = (isISBN(_primary_code)) ? addISBNDashes(_primary_code, _condition, false) : "ISNT";
            navigator.clipboard.writeText(_copied).then(() => {
                showMessage("Copied");
            }).catch(err => { showError({ error: "Can't copy" }) });
        }
    }

    const handlePaste = (e) => {
        if (index === "primary_code") {
            alert("paste")
        }
    }

    const [stock_data, setStockData] = useState((new_obj) ? new_obj : props.stock_data || {});



    useEffect(() => {
        if (new_obj) {
            setStockData(new_obj)
        }
    }, [new_obj])


    const showBindingPicker = (_binding = refs.current["binding"].value) => {
        window.bm_state.value = ROUTES.HELPERS.BINDINGS;
        refs.current["binding"].blur();
        createModal({
            offset: [0, -130],
            component: <Bindings value={_binding} route={ROUTES.HELPERS.BINDINGS} />, refElement: refs.current["binding"], closable: true, callback: (e) => {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
                if (e) { setStockData({ ...stock_data, "binding": e }) }

                refs.current[index].focus();
            }
        })

    }

    const showAuthorPicker = (_author = refs.current["author"].value, _init_data = [], _callback = false) => {

        if (!refs.current["author"].value) {
            showError({ error: "Requires at least start of author's last name." })
            return;
        }
        refs.current["author"].blur();
        window.bm_state.value = ROUTES.INVENTORY.AUTHORPICKER;
        createScreen({
            signal: signal,
            component: <AuthorPickerScreen init_data={_init_data} stock_data={stock_data} author={refs.current["author"].value} route={ROUTES.INVENTORY.AUTHORPICKER} />, closable: true, title: "Select Author",
            callback: (_obj) => {

                if (_callback) {
                    _callback(_obj);
                    return;
                }
                if (_obj?.author) {
                    setStockData({ ...stock_data, "author": _obj.author })
                    next();
                } else {
                    refs.current["author"].focus();
                }


                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            }
        });

    }

    const openPopover = () => {

        switch (index) {

            case "title":
                refs.current["title"].blur();
                window.bm_state.value = ROUTES.HELPERS.TITLELINK_DATA;
                createScreen({
                    signal: signal,
                    component: <TitleLinkData controller={controller} stock_data={stock_data} route={ROUTES.HELPERS.TITLELINK_DATA} />, closable: true, title: "Titlelink Data",
                    callback: (_obj) => {
                        if (_obj) {
                            setStockData(_obj)
                        }
                        refs.current["title"].focus();
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                    }
                });
                break;


            case "used_condition":
                window.bm_state.value = ROUTES.HELPERS.USED_CONDITIONS;
                refs.current["used_condition"].blur();
                createModal({
                    offset: [0, -80],
                    component: <UsedConditions value={refs.current["used_condition"].value} route={ROUTES.HELPERS.USED_CONDITIONS} />, refElement: refs.current["used_condition"], closable: true, callback: (e) => {
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                        if (e) { setStockData({ ...stock_data, "used_condition": e }) }

                        refs.current[index].focus();
                    }
                })
                break;

            case "condition_code":
                window.bm_state.value = ROUTES.HELPERS.CONDITIONS;
                refs.current["condition_code"].blur();
                createModal({
                    offset: [0, -130],
                    component: <Conditions value={refs.current["condition_code"].value} route={ROUTES.HELPERS.CONDITIONS} />, refElement: refs.current["condition_code"], closable: true, callback: (e) => {
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                        if (e) { setStockData({ ...stock_data, "condition_code": e }) }
                        refs.current[index].focus();
                    }
                })
                break;

            case "binding":
                showBindingPicker();
                break;

            case "author":
                showAuthorPicker();
                break;


            case "bisac":
                window.bm_state.value = ROUTES.HELPERS.BISACS;
                refs.current["bisac"].blur();
                createModal({
                    offset: [0, -330],
                    component: <Bisacs value={refs.current["bisac"].value} route={ROUTES.HELPERS.BISACS} />, refElement: refs.current["bisac"], closable: true, callback: (e) => {
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                        if (e) { setStockData({ ...stock_data, "bisac": e }) }
                        refs.current[index].focus();
                    }
                })
                break;


            case "note":
                refs.current["note"].blur();
                window.bm_state.value = ROUTES.HELPERS.NOTE_INDICATORS;
                createModal({
                    component: <NoteIndicators route={ROUTES.HELPERS.NOTE_INDICATORS} />, refElement: refs.current["note"], closable: true, title: "Select Author",
                    callback: (_obj) => {
                        refs.current["note"].focus();
                        if (_obj?.value) {
                            setStockData(prev => ({ ...prev, note: { ...prev.note, full_note: _obj.value + " " + (prev.note?.full_note || "") } }));
                            requestAnimationFrame(() => {
                                refs.current["note"].setSelectionRange(_obj.value.length + 1, _obj.value.length + 1);
                            });
                        }
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                    }
                });
                break;


            case "out_of_stock_status":
                refs.current["out_of_stock_status"].blur();
                window.bm_state.value = ROUTES.HELPERS.OS_STATS;
                createModal({
                    offset: [0, -185],
                    component: <OSStats value={refs.current["out_of_stock_status"].value} route={ROUTES.HELPERS.OS_STATS} />, refElement: refs.current["out_of_stock_status"], closable: true,
                    callback: (e) => {
                        refs.current["out_of_stock_status"].focus();
                        if (e) { setStockData({ ...stock_data, "out_of_stock_status": e }) }
                        window.bm_state.value = ROUTES.INVENTORY.EDIT;
                    }
                });
                break;
        }
    }


    const saveStartField = () => {
        if (edit) {
            save("inventory_start_field", index);
            showMessage("Future Editing will start with this field");
        }
    }


    // Focus the item
    useEffect(() => {
        if (!edit) { return; }

        // mapping stuff from title link...
        if (!in_stock && (!stock_data.note || !stock_data.original_publisher)) {
            let _note = { full_note: stock_data.series, alert: false, discount: null, dont_adjust_oh: false, extra_price: null, sell_price: null }
            let _original_publisher = (stock_data?.publisher) ? stock_data.publisher.toUpperCase().slice(0, 5) : "";
            setStockData({ ...stock_data, "original_publisher": _original_publisher, "note": _note })
        }

        let _r = findField(window.event?.clientX ?? 0, window.event?.clientY ?? 0);
        if (_r) {
            _r.focus()
        } else {
            let _start_key = tabs.find(item => item.key === getSaved("inventory_start_field"));
            if (_start_key) {
                refs.current[_start_key.key].focus();
            } else {
                refs.current["title"].focus();
            }
        }
    }, [edit])


    // Keyboard Events
    useEffect(() => {
        if (edit) {
            refs.current[index].focus();
        }
        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next(e) },
            { key: KBD.ARROW_UP, action: (e) => prev(e) },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.ENTER, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => { setStockData(props.stock_data); switchEdit(); } },
            { key: KBD.PAGE_DOWN, action: (e) => { handleSaveTitle() } },
            { key: KBD.CTRL_C, action: (e) => { handleCopy(e) } },
            { key: KBD.PAGE_UP, action: (e) => { openPopover() } },
            { key: KBD.F9, action: (e) => { saveStartField() } },
            // { key: KBD.CTRL_V, action: (e) => { handlePaste(e) } },
        ];
        const cleanup = listen(controller, ROUTES.INVENTORY.EDIT, actions, (e) => {


            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V, KBD.F9, KBD.F6], [], [KBD.F6, KBD.CTRL_C, KBD.CTRL_V], null);
        return cleanup;
    }, [index, stock_data]);






    useEffect(() => {
        if (new_obj) return;
        setStockData(props.stock_data || {});

    }, [props.stock_data])





    const {



        // author = "",
        available_on_hand = null,

        backroom = null,
        // binding = "",
        // bisac = "",
        bisac_description = "",
        // carton_quantity = null,
        category_1 = null,
        category_2 = null,
        category_description = "",
        category_tax_code = "",
        condition_code = "",
        cost = null,
        cost_lock = "",
        held_point_of_sale = null,
        minimum_onhand = null,
        note = {
            full_note: "",
            alert: false,
            discount: null,
            dont_adjust_oh: false,
            extra_price: null,
            sell_price: null
        },
        on_order = null,
        //original_publisher = "",
        out_of_stock_status = "",
        pending_on_order = null,
        pending_return = null,
        price = null,
        // primary_code = "",
        profit_cost = null,
        profit_sell = null,
        // publication_date = null,
        receive_date = null,
        returnable = "",
        secondary_code = "",
        section = "",
        sell_price = null,
        special_on_order_pending = null,
        sold_1 = "",
        sold_10 = "",
        sold_11 = "",
        sold_12 = "",
        sold_13 = "",
        sold_14 = "",
        sold_2 = "",
        sold_3 = "",
        sold_4 = "",
        sold_5 = "",
        sold_6 = "",
        sold_7 = "",
        sold_8 = "",
        sold_9 = "",
        special_on_order = null,
        // status = "",
        stock_id = "",
        stocked_1 = "",
        stocked_10 = "",
        stocked_11 = "",
        stocked_12 = "",
        stocked_13 = "",
        stocked_14 = "",
        stocked_2 = "",
        stocked_3 = "",
        stocked_4 = "",
        stocked_5 = "",
        stocked_6 = "",
        stocked_7 = "",
        stocked_8 = "",
        stocked_9 = "",
        supplier_1 = "",
        supplier_2 = "",
        supplier_3 = "",

        peer_1 = "",
        peer_10 = "",
        peer_11 = "",
        peer_12 = "",
        peer_13 = "",
        peer_14 = "",
        peer_2 = "",
        peer_3 = "",
        peer_4 = "",
        peer_5 = "",
        peer_6 = "",
        peer_7 = "",
        peer_8 = "",
        peer_9 = "",
        peer_header = "",
        peer_onhand = 0,
        peer_on_order = 0,
        peer_total_locations = 0,
        last_received = 0,
        last_sold = 0,
        // title = "",
        total_onhand = null,
        total_received = null,
        total_returned = null,
        total_sold = null,
        used_condition = "",
        weight = "",

        week_sold = null,
        week_recived = null,
        week_peer = null,

        // tax stuff
        tax_code = "",

        has_message = false,

    } = stock_data;


    const title_link = {
        ...stock_data,
        ...stock_data?.title_link
    };

    const
        {
            // author = "",
            author_2 = "",
            author_3 = "",
            // binding = "",
            binding_format = "",
            // bisac = "",
            // carton_quantity = null,
            data_source = "",
            depth = null,
            height = null,
            language = "",
            pages = null,
            price_ca = null,
            price_us = null,
            // primary_code = "",
            // publication_date = "",
            publisher = "",
            series = "",
            series_number = "",
            // status = "",
            subject = "",
            subjects = "",
            subtitle = "",
            // title = "",
            upc = "",
            updated = "",
            width = null,
            audience_min = null,
            audience_max = null,
            audience_type = "" // A or G

        } = {
            ...stock_data,
            ...stock_data?.title_link
        };

    // Overlap - pref for stock data
    const author = (stock_data.author) ? stock_data.author.slice(0, 25) : title_data?.author?.slice(0, 25);
    const binding = (stock_data.binding) ? stock_data.binding : title_data.binding;
    const bisac = (title_link?.subjects) ? title_link?.subjects : stock_data.bisac;
    const carton_quantity = (stock_data.carton_quantity) ? stock_data.carton_quantity : (title_data.carton_quantity) ? title_data.carton_quantity : null;
    const primary_code = (stock_data.primary_code) ? stock_data.primary_code : (title_data.primary_code) ? title_data.primary_code : "";
    const publication_date = (stock_data.publication_date) ? dayjs(stock_data.publication_date).valueOf() : dayjs(title_data.publication_date).valueOf();
    const status = (stock_data.status) ? stock_data.status : title_data.status;
    const title = (stock_data.title) ? stock_data.title.slice(0, 40) : title_data?.title?.slice(0, 40);
    const rank = (title_data.rank) ? title_data.rank : stock_data.rank;
    const original_publisher = (stock_data?.publisher) ? stock_data.publisher.slice(0, 5).toUpperCase() : stock_data?.original_publisher;

      
    const audience = (audience_min && audience_max && audience_type === "A") ? audience_min + "-" + audience_max : "";


    const has_sos = note?.full_note?.includes("//SOS");
    const getPrimaryCode = () => {
        return addISBNDashes(primary_code, condition_code)
    }

    const drawBisacLabel = () => {
        if (!bisac) return "";
        let _lbl = bisac.substr(0, 3);
        if (_lbl && bisac_description) {
            return _lbl + "-" + bisac_description;
        } else {
            return bisac;
        }

    }

    const splitTitle = (str) => {
        const i = str.indexOf(":");
        return i === -1 ? str : str.slice(0, i);
    };

    const can_quick_order = (window.bm_state.value === ROUTES.INVENTORY.INVENTORY);
    const can_quick_search = (window.bm_state.value === ROUTES.INVENTORY.INVENTORY && (controller === "inventory" || controller === "reports" || controller === "global"));


    const selectSearchParam = (_type) => {


        let _options = [];

        if (_type === "Author") {
            _options = [
                { label: author, value: author },
                ...(author_2 ? [{ label: author_2, value: author_2 }] : []),
                ...(author_3 ? [{ label: author_3, value: author_3 }] : []),
            ]
        }

        if (_type === "Supplier") {
            _options = [
                { label: supplier_1, value: supplier_1 },
                ...(supplier_2 ? [{ label: supplier_2, value: supplier_2 }] : []),
                ...(supplier_3 ? [{ label: supplier_3, value: supplier_3 }] : []),
            ]
        }


        drawPicker({
            controller: controller,
            title: "Select", closeable: true, height: 300, route: ROUTES.INVENTORY.INVENTORY, callback: (e) => {
                if (e) {
                    quickSearch(_type, true, e);
                }

            }, offset: [0, 10],
            options: _options
        })

    }


    const quickSearch = (_type = "", skip = false, overide = "") => {

        if (!can_quick_search) {
            return;
        }
        const _isbn = primary_code;

        let _params = {
            scope: "active",
            sort: "in_stock",
        }
        let _local_params = {}
        let _title_link = true;
        let _message = "";
        let _endpoint = "";
        let _search_type = ""
        let _term = ""

        switch (_type) {
            case "ISBN":
                _message = _isbn;
                _params.term = _isbn;
                _params.type = "isbn";
                break;
            case "Title":
                _message = splitTitle(title);
                _params.term = splitTitle(title);
                _params.type = "keyword";
                break;
            case "Author":

                if (!skip && (author_2 || author_3)) {
                    selectSearchParam(_type)
                    return;
                }

                _message = (skip) ? overide : author;
                _params.term = (skip) ? overide : author;
                _params.type = "author";
                break;
            case "Bisac":
                _message = bisac;
                _params.term = "";
                _params.limit = 100;
                _params.bisac = bisac;
                _params.type = "keyword";
                break;
            case "Publisher":
                _message = "publisher";
                _params.term = _isbn;
                _params.term_lookup = "publisher";
                _params.type = "publisher";
                break;
            case "Series":
                _message = "series";
                _params.term = _isbn;
                _params.term_lookup = "series";
                _params.type = "keyword";
                break;
            case "Supplier":

                if (!skip && (supplier_2 || supplier_3)) {
                    selectSearchParam(_type)
                    return;
                }

                _endpoint = "stock.searchSupplier";
                _search_type = "supplier";
                _title_link = false;
                _message = (skip) ? overide.trim() : supplier_1.trim();
                _term = (skip) ? overide.trim() : supplier_1.trim();
                _local_params.limit = 100;
                _local_params.title = "";
                _local_params.supplier = (skip) ? overide.trim() : supplier_1.trim();
                break;
            case "Class":
                _endpoint = "stock.searchClass";
                _search_type = "class";
                _title_link = false;
                _message = (category_2) ? category_1.trim() + "-" + category_2.trim() : category_1.trim();
                _term = (category_2) ? category_1.trim() + "-" + category_2.trim() : category_1.trim();
                _local_params.limit = 100;
                _local_params.title = "";
                _local_params.class_1 = category_1.trim();
                _local_params.class_2 = category_2.trim();
                break;
            default: return;
        }

        if (!_title_link) {

            callSearch(_endpoint, _local_params, _type, _term, (_s, _r, type_, searchMsg_, term_) => {
                if (_s) {
                    props.onSearch({ data: _r || [], type: type_, term: term_, message: <>{_type} <em className="text-yellow">`{_message}`</em></>, new_tab: true })
                } else {
                    showError(_r);
                }
            })
            return;
        }

        callTitleLink(_params, (_s, _r) => {
            if (_s) {

                if (_message === "series") {
                    _message = _r?.[0]?.title_link?.series || "Series";
                }
                if (_message === "publisher") {
                    _message = _r?.[0]?.title_link?.publisher || original_publisher || "Publisher";
                }

                let _full_view = (_params.term_lookup === "series");

                

                props.onSearch({ data: _r || [], type: "title_link", term: _params.term, message: <>{_type}<em className="text-yellow">`{_message}`</em></>, new_tab: true }, "", _full_view)
            } else {
                showError(_r);
            }
        }
        )


        //         {
        //     "term": "another",
        //     "type": "keyword",
        //     "scope": "active",
        //     "sort": "in_stock",
        //     "limit": 100,
        //     "session_id": "T38icuKQRpOzuc7JFffbYFEJZG0w",
        //     "subscription_id": 3812091055342052
        // }

    }

    const drawDiffDays = (_lr, _ls) => {

        if (!_lr || !_ls) {
            return (<></>);
        }

        if (_lr > _ls) {
            return (<></>);
        }

        return (<>({dayjs(_ls).diff(dayjs(_lr), "day")} days)</>)


    }
    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }



    const selectSupplier = (_search) => {
        blurField();
        const route = window.bm_state.value;
        window.bm_state.value = ROUTES.SUPPLIERS.SUPPLIERS;
        createScreen({
            signal: signal,
            component: <SuppliersController controller={controller} is_modal search={_search.trim()} route={ROUTES.SUPPLIERS.SUPPLIERS} />, closable: false, title: "Select Supplier",
            callback: (_obj) => {

                if (_obj?.code) {

                    window.bm_state.value = route;
                    setStockData({ ...stock_data, [index]: _obj?.code });
                    next();
                } else {
                    focusField();
                    window.bm_state.value = route;
                }




            }
        });
    }

    const drawCard = () => {
        return (
            <>
                {/* <Row gap={8} align="flex-start">
                        <Row.Item width={37}><Label>ISBN</Label></Row.Item>
                        <Row.Item flexGrow={1}><Input doubleclick={KBD.PAGE_UP} validator={VALIDATE.EMPTY} {...editProps("title")}  value={title} /></Row.Item>

                 </Row>
                 <div className="shim" /> */}


                <Space size={8}>
                    <Label button={can_quick_search} onClick={() => quickSearch("ISBN")} width={37}>ISBN</Label>
                    <Space size={4}>
                        <Input remember="primary_code" onCopy={() => { copyToClipboard(addISBNDashes(primary_code, condition_code, false)) }} grow className={(edit) ? "dim" : (in_stock) ? "" : "error"} maxLength={15} validator={VALIDATE.EMPTY} {...editProps("primary_code")} width={(edit) ? 141 : 175} value={(edit) ? primary_code : getPrimaryCode()} />
                        {(edit && <Input className={(edit) ? "dim" : "normal"} remember="condition_code" uppercase maxLength={1} doubleclick={KBD.PAGE_UP}  width={20} value={condition_code} />)}
                        <Input remember="used_condition" uppercase maxLength={1} doubleclick={KBD.PAGE_UP} {...editProps("used_condition")} width={(edit) ? 100 : 100} secondary validator={VALIDATE.CHARS(used_conditions_data.map(item => item.value), true)} render={(used_conditions_data?.find(item => item.value !== " " && item.value === used_condition)?.label || " ")} value={used_condition || ""} />
                    </Space>
                    <Label><nobr>UPC/EAN</nobr></Label>
                    <Input remember="secondary_code" maxLength={15} {...editProps("secondary_code")} width={166} secondary value={secondary_code} />
                    <Label grow>Price</Label>
                    <PriceField remember="price" maxLength={7} validator={VALIDATE.EMPTY} {...editProps("price")} price right width={70} value={price} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label button={can_quick_search} onClick={() => quickSearch("Title")} maxLength={55} width={37}>Title</Label>
                    <Input remember="title" onCopy={() => { copyToClipboard(title) }} doubleclick={KBD.PAGE_UP} validator={VALIDATE.EMPTY} {...editProps("title")} width={365} value={title} />
                    <Label button={can_quick_search} onClick={() => quickSearch("Series")} width={43}>Series</Label>
                    <Input className={(edit) ? "dim" : "normal"} width={173} value={series} />
                    <Label width={0}>#</Label>
                    <Input className={(edit) ? "dim" : "normal"} width={30} value={series_number} />

                    <Label grow className={(edit || !(sell_price > 0 && sell_price !== price)) ? "invisible" : ""} width={31}>Sale</Label>
                    <PriceField className={(edit || !(sell_price > 0 && sell_price !== price)) ? "invisible" : "text-red-bg"} right width={70} value={(sell_price > 0 && sell_price !== price) ? sell_price : ""} />
                </Space>

                <div className="shim" />
                <Float>
                    <Space grow size={8}>
                        <Label button={can_quick_search} onClick={() => quickSearch("Author")} width={37}>Auth</Label>
                        <Space size={4}>
                            <Input remember="author" grow onCopy={() => { copyToClipboard(author) }} maxLength={25} doubleclick={KBD.PAGE_UP} {...editProps("author")} onFocus={() => { setIndex("author"); tempAuth.current = author; }} onEnter={(_author) => {

                                if (_author.toUpperCase() === tempAuth.current.toUpperCase()) {
                                    next();
                                    return;
                                }

                                searchAuthor(_author, (_s, _r) => {

                                    if (_s) {
                                        if (_r.length !== 1 || (_r.length === 1 && author.toUpperCase() !== _r[0].author.toUpperCase())) {
                                            _r.unshift({
                                                author: author,
                                                add: true,
                                                titles: []
                                            });
                                            showAuthorPicker(_author, _r);
                                            return;
                                        } else {
                                            setStockData({ ...stock_data, "author": _r[0].author })
                                            next();
                                        }
                                    } else {
                                        showError(_r);
                                    }

                                })
                            }} width={210} value={author} />
                            <Input grow onCopy={() => { copyToClipboard(author_2) }} className={(edit) ? "dim" : ""} width={210} secondary value={author_2} />
                            <Input grow onCopy={() => { copyToClipboard(author_3) }} className={(edit) ? "dim" : ""} width={209} secondary value={author_3} />
                        </Space>
                    </Space>
                    <Space>
                        <Label>Binding</Label>
                        <Input remember="binding" maxLength={2} doubleclick={KBD.PAGE_UP} {...editProps("binding")} width={32} uppercase onEnter={(_binding) => {
                            searchBindings(_binding, (_s, _r) => {
                                if (_s) {

                                    let _f = _r.find(item => item.binding === _binding);
                                    if (_f) {
                                        setStockData({ ...stock_data, "binding": _f.binding });
                                        next();
                                    } else {
                                        showBindingPicker(_binding);
                                    }
                                } else {
                                    showError(_r);
                                }
                            })

                        }} value={binding} />
                    </Space>
                </Float>
                <div className="shim" />
                <Float>
                    <Space grow size={8}>
                        <Label button={can_quick_search} onClick={() => quickSearch("Supplier")} width={37}>Supl</Label>
                        <Space grow size={4}>
                            
                            <Input remember="supplier_1" uppercase grow validator={VALIDATE.EMPTY} maxLength={6} {...editProps("supplier_1")} onPageUp={(e) => selectSupplier(e)} width={80} value={supplier_1} />
                            <Input remember="supplier_2" uppercase grow maxLength={6} {...editProps("supplier_2")} width={80} secondary onPageUp={(e) => selectSupplier(e)} value={supplier_2} />
                            <Input remember="supplier_3" uppercase grow maxLength={6} {...editProps("supplier_3")} width={80} secondary onPageUp={(e) => selectSupplier(e)} value={supplier_3} />
                        </Space>
                        <Label button={can_quick_search} onClick={() => quickSearch("Publisher")} >Publ</Label>
                        <Input remember="original_publisher" limit={5} uppercase {...editProps("original_publisher")} width={96} secondary value={original_publisher} />

                    </Space>
                    <Space grow size={5}>
                        <Label width={35}>Pubdt</Label>
                        <DateInput width={92} onFilled={(e) => { update("publication_date", e); next(); }} timestamp {...editProps("publication_date")} value={publication_date} />
                        {/* <Input remember="publication_date" number validator={VALIDATE.DATE} style={{ "color": (!edit && publication_date > dayjs().unix()) ? "var(--text-teal)" : "inherit" }} maxLength={10} {...editProps("publication_date")} width={89} render={bm_date(publication_date)} value={publication_date} /> */}
                    </Space>
                </Float>
                <div className="shim" />
                <Space size={8}>
                    <Label button={can_quick_search} onClick={() => quickSearch("Class")} width={37}>Class</Label>
                    {(!edit &&
                        <Space size={3}>
                            <Input width={112} value={category_1} />
                            <Label>-</Label>
                            <Input width={112} value={category_2} />
                        </Space>
                    )}
                    {(edit &&
                        <Space size={3}>
                            <CategorySelectorInput remember="category_1" controller={controller} doubleclick={KBD.PAGE_UP} command={KBD.PAGE_UP} controlled field="one" onChange={(_v) => setStockData({ ...stock_data, "category_1": _v })} onSelect={(_v, c1, c2) => {setStockData({ ...stock_data, "category_1": c1, "category_2": c2 }); setIndex("bisac");}} overide {...editProps("category_1")} route={ROUTES.INVENTORY.EDIT} width={112} category_2={category_2} category_1={category_1} value={category_1} />
                            <Label>-</Label>
                            <CategorySelectorInput remember="category_2" controller={controller} doubleclick={KBD.PAGE_UP} command={KBD.PAGE_UP} controlled field="two" onChange={(_v) => setStockData({ ...stock_data, "category_2": _v })} onSelect={(_v, c1, c2) => {setStockData({ ...stock_data, "category_1": c1, "category_2": c2 }); next();}} overide {...editProps("category_2")} route={ROUTES.INVENTORY.EDIT} width={112} category_2={category_2} category_1={category_1} value={category_2} />
                        </Space>
                    )}


                    <Label>Se</Label>
                    <Input className={(edit) ? "dim" : ""} width={28} secondary value={section} />
                    <Label button={can_quick_search} onClick={() => quickSearch("Bisac")} width={38}>BISAC</Label>
                    <Input remember="bisac" grow maxLength={9} doubleclick={KBD.PAGE_UP} {...editProps("bisac")} width={289} secondary value={(edit) ? bisac : drawBisacLabel()} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label width={37}>Note</Label>
                    <Space grow size={5}>
                        {(status && <Input width={70} style={{ "textAlign": "center" }} warning value={status} />)}
                        <Input remember="note" grow maxLength={55} doubleclick={KBD.PAGE_UP} {...editProps("note")} width={(status) ? 600 - 85 : 600} secondary value={(edit) ? note.full_note : drawNote(note.full_note)} />
                        {(has_message && <span style={{ "cursor": "pointer" }} onClick={() => kbdEvent(KBD.M)} class="ui-pulse"><ToolTip text="View inventory message"><MessageIcon /></ToolTip></span>)}
                        {(condition_code === "U" && <Label style={{ "fontSize": "12px", "textAlign": "center" }} width={68}><nobr><em><a style={{ "textDecoration": "underline" }}>{(edit) ? "" : "Used Notes"}</a></em></nobr></Label>)}
                    </Space>
                </Space>
            </>
        )
    }



    const drawStatusCard = () => {
        return (
            <>
                <Space size={8}>
                    <Label width={45}>1stRcvd</Label>
                    <DateInput width={92} onFilled={(e) => { update("receive_date", e); next(); }} timestamp {...editProps("receive_date")} value={receive_date} />
                    {/* <Input remember="receive_date" validator={VALIDATE.DATE} maxLength={10} {...editProps("receive_date")} width={90} render={bm_date(receive_date)} value={receive_date} /> */}
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={93}>Total OH</Label>
                    <Input maxLength={4} number  {...editProps("total_onhand")} right className={(has_sos) ? "sos" : (edit) ? "dim" : "normal"} width={44} render={drawNumber(total_onhand)} value={total_onhand} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={93}>Min OH</Label>
                    <Input remember="minimum_onhand" maxLength={4} number {...editProps("minimum_onhand")} right className={(minimum_onhand > available_on_hand) ? "error" : "normal"} width={44} render={drawNumber(minimum_onhand)} value={minimum_onhand} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={93}>Backroom</Label>
                    <Input remember="backroom" maxLength={4} number {...editProps("backroom")} right className={((available_on_hand || backroom) && backroom >= available_on_hand) ? "error" : "normal"} width={44} render={drawNumber(backroom)} value={backroom} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={93}>PendRtns</Label>
                    <Input right className={(edit) ? "dim" : "normal"} width={44} render={drawNumber(pending_return)} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    {(window.beta) ? <Label width={93}>Held POS</Label> : <Label button={can_quick_order} width={93} onClick={() => kbdEvent(KBD.R)}>Held POS</Label>}
                    <Input right className={(edit) ? "dim" : (window.beta) ? "bold" : "bold input-link"} style={{ "color": "var(--text-pink)" }} width={44} onClick={() => kbdEvent(KBD.R)} value={drawNumber(held_point_of_sale)} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Space size={5}>
                        <Label className={(edit) ? "" : ""}>P</Label>
                        <Input right className={(edit) ? "dim" : "normal"} width={44} value={drawNumber(special_on_order_pending)} />
                        <Label width={0} button={can_quick_order} onClick={() => kbdEvent(KBD.R)}>S/O</Label>
                        <Input right className={(edit) ? "dim" : (window.beta) ? "normal" : "normal input-link"} width={44} onClick={() => kbdEvent(KBD.R)} value={drawNumber(special_on_order)} />
                    </Space>

                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Space size={5}>
                        <Label className={(edit) ? "" : "text-orange"}>P</Label>
                        <Input right className={(edit) ? "dim" : "text-black text-orange-bg input-link"} width={44} value={drawNumber(pending_on_order)} />
                        <Label button={can_quick_order} className={(edit) ? "" : "text-orange"} width={23} onClick={() => kbdEvent(KBD.O)}>OO</Label>
                        <Input onClick={() => kbdEvent(KBD.O)} right className={(edit) ? "dim" : "text-black text-orange-bg input-link"} width={44} value={drawNumber(on_order)} />
                    </Space>
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label className={(edit) ? "" : "text-green bold"} width={93}>Avail OH</Label>
                    <Input right className={(has_sos) ? "sos" : (edit) ? "dim" : "text-green-bg text-black bold"} width={44} value={drawNumber(available_on_hand)} />
                </Space>
            </>
        )
    }

    const drawExtra = () => {
        return (
            <div style={{ "width": "175px", "overflow": "hidden" }}>
                {(!edit && <><Label width={177}>PC{drawPC(cost, profit_cost, profit_sell)}{(cost_lock === "L" && <span className="text-red">{cost_lock}</span>)}&nbsp;</Label><div style={{ "height": "5px" }} className="shim" /></>)}
                {(edit &&
                    <Space size={5}>
                        <Label width={57}>Cost</Label>
                        <PriceField maxLength={7} validator={VALIDATE.EMPTY} {...editProps("cost")} className={(edit) ? "dim" : "normal"} price right width={70} render={drawPrice(cost, true)} value={cost} />
                        <Input style={{ "textAlign": "center" }} className={(edit) ? "dim" : "normal"} maxLength={1} chars={["L"]} validator={VALIDATE.CHARS(["L"], true)} uppercase {...editProps("cost_lock")} width={20} value={cost_lock} />
                    </Space>
                )}

                <Float>
                    <div></div>
                    <Space size={8}>
                        <a onClick={() => copyToClipboard(primary_code)}><CopyIcon /></a>
                        <a onClick={() => copyToClipboard(primary_code)}><Label className="text" style={{ "fontSize": "16px" }}>{primary_code}</Label></a>
                    </Space>
                </Float>

                <Space size={8}>
                    <Label width={115}>O/S Stat</Label>
                    <Input remember="out_of_stock_status" maxLength={4} uppercase validator={VALIDATE.ENUM(os_stats.map(item => item.value).concat([""]))} doubleclick={KBD.PAGE_UP} {...editProps("out_of_stock_status")} medium className={(edit) ? "" : "text-red"} width={56} value={out_of_stock_status} />
                </Space>
                <div className="shim" />
                <Space size={2}>
                    <Label>Pg</Label>
                    <Input medium className={(edit) ? "dim" : "normal"} width={56} value={pages} />
                    <Label>Age</Label>
                    <Input medium className={(edit) ? "dim" : "normal"} width={52} value={audience} />
                </Space>
                <div className="shim" />
                <Space size={3}>
                    <Label>CQ</Label>
                    <Input remember="carton_quantity" number maxLength={3} {...editProps("carton_quantity")} right medium className="normal" width={34} value={carton_quantity} />
                    <Label width={21}>Wt</Label>
                    <Input remember="weight" maxLength={5} {...editProps("weight")} right medium className="normal" width={73} value={weight} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={43}>Size</Label>
                    <Input medium className={(edit) ? "dim" : "normal"} width={115} value={drawSize(width, height)} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label>Rtnbl</Label>
                    <Input remember="returnable" style={{ "textAlign": "center" }} uppercase chars={["Y", "N"]} {...editProps("returnable")} medium className={(edit) ? "normal" : "normal text-red"} width={12} value={returnable} />
                    <Label width={45} >RtnTtl</Label>
                    <Input maxLength={4} number {...editProps("total_returned")} right medium className={(edit) ? "dim" : "normal"} width={40} value={drawNumber(total_returned)} />
                </Space>
                <div className="shim" />

                <Space size={8}>
                    <Label width={33}>Publ</Label>
                    <Input medium className={(edit) ? "dim" : "normal"} width={125} value={publisher} />
                </Space>
                <div className="shim" />
                <Space size={3}>

                    <Float>
                        <div style={{ fontSize: "13px" }}>

                            <div style={{ display: "flex", gap: 12, whiteSpace: "nowrap" }}>
                                {(peer_total_locations > 0 && peer_on_order > 0) && (
                                    <ToolTip
                                        text={
                                            <div style={{ textAlign: "center" }}>
                                                <strong>{peer_total_locations}</strong> peer stores have an average of
                                                <br />
                                                <strong>{Math.round(peer_on_order / peer_total_locations)}</strong> copies of this forthcoming title on order.
                                            </div>
                                        }
                                    >
                                        <span style={{ color: "var(--text-teal)" }}>
                                            FC: {Math.round(peer_on_order / peer_total_locations)} / {peer_total_locations}
                                        </span>
                                    </ToolTip>
                                )}

                                {rank < 0 && (
                                    <ToolTip
                                        width={300}
                                        text={
                                            <div style={{ textAlign: "center" }}>
                                                Based on preorders from {peer_total_locations} stores, this title is currently ranked #
                                                {(rank + 1) - session.minimum_rank} in popularity, where a forthcoming rank of #1
                                                would denote the most widely ordered and anticipated title at the moment.
                                            </div>
                                        }
                                    >
                                        <span style={{ color: "var(--text-teal)" }}>
                                            FC Rank: {(rank + 1) - session.minimum_rank}
                                        </span>
                                    </ToolTip>
                                )}
                            </div>

                            <div style={{ whiteSpace: "nowrap" }}>
                                {last_received > 0 && (
                                    <div style={{ color: "var(--label)" }}>
                                        LR: <span style={{ color: "var(--text)" }}>{bm_date(last_received)}</span>
                                    </div>
                                )}

                                {last_sold > 0 && (
                                    <div style={{ display: "flex", gap: 8, whiteSpace: "nowrap" }}>
                                        <div style={{ color: "var(--label)" }}>
                                            LS: <span style={{ color: "var(--text)" }}>{bm_date(last_sold)}</span>
                                        </div>

                                        <div style={{ color: "var(--label)" }}>
                                            {drawDiffDays(last_received, last_sold)}
                                        </div>
                                    </div>
                                )}

                                {rank >= 0 && (
                                    <ToolTip
                                        width={300}
                                        text={
                                            <div style={{ textAlign: "center" }}>
                                                Based on sales from {peer_total_locations} stores, this title is currently ranked #{rank}
                                                in popularity, where a sales rank of #1 would denote the bestselling title at the moment.
                                            </div>
                                        }
                                    >
                                        <div style={{ color: "var(--label)", whiteSpace: "nowrap" }}>
                                            Rank: <span style={{ color: "var(--text)" }}>{rank}</span>
                                        </div>
                                    </ToolTip>
                                )}
                            </div>

                        </div>
                    </Float>
                </Space>
            </div>
        )
    }



    const drawShim = () => {
        return (<div style={{ "backgroundColor": "#303030", "height": "1px", "width": "100%", "marginLeft": "0px" }}></div>)
    }

    const drawReceived = () => {


        // THIS WORKS!
        // return (
        //     <div style={{ display: "flex", gap: "8px", width: "100%" }}>
        //         <div style={{ flex: 1, minWidth: 0, display: "flex" }}>
        //             <input
        //                 type="text"
        //                 placeholder="Input 1"
        //                 style={{
        //                     width: "10px",
        //                     minWidth: 0,
        //                     boxSizing: "border-box",
        //                     flexGrow: 1,
        //                 }}
        //             />
        //         </div>

        //     </div>

        // )


        if (!in_stock && !edit) {
            return (
                <Space size={0} justifyContent="stretch" width={731} >
                    <div style={{ "width": "47px" }}><Cell style={{ "background": "none" }} width={46} >Rcvd</Cell></div>
                    <div style={{ "width": "100%" }}><Cell double className="text-red-bg text bold" style={{ "background": "none" }}  ><nobr>Not in inventory</nobr></Cell></div>
                </Space>
            )
        }




        return (
            <Space grow size={0} justifyContent="stretch" >
                <Cell className="text-orange" style={{ "background": "none", "fontSize": "14px" }} width={46} >Rcvd</Cell>
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_1")} cell double width={39} value={stocked_1} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_2")} cell border width={39} value={stocked_2} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_3")} cell border width={39} value={stocked_3} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_4")} cell border width={39} value={stocked_4} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_5")} cell border width={39} value={stocked_5} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_6")} cell border width={39} value={stocked_6} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_7")} cell border width={39} value={stocked_7} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_8")} cell border width={39} value={stocked_8} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_9")} cell border width={39} value={stocked_9} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_10")} cell border width={39} value={stocked_10} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_11")} cell border width={39} value={stocked_11} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_12")} cell border width={39} value={stocked_12} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_13")} cell border width={39} value={stocked_13} />
                <Input grow right className={(!edit) ? "text-orange" : ""} maxLength={4} {...editProps("stocked_14")} cell border width={39} value={stocked_14} />
                <Input grow right className={(!edit) ? "text-orange" : ""} style={{ "backgroundColor": "#000", "fontWeight": "700" }} number maxLength={7} {...editProps("total_received")} cell double width={40} value={total_received} />
                {/* <Input right className={(!edit) ? "text-orange" : ""} number maxLength={7} {...editProps("total_received")} cell double width={60} value={week_recived} /> */}
            </Space>
        )
    }


    const getMonthHeaders = () => {
        return Array.from({ length: 12 }, (_, i) =>
            dayjs()
                .subtract(11 - i, "month") // go back 11 → 0 months
                .format("MMM")
        );
    };

    const drawMonthly = () => {

        const _arr = (monthly_sold) ? monthly_sold : Array(36).fill(0);

        const rows = [
            _arr.slice(24, 36),
            _arr.slice(12, 24),
            _arr.slice(0, 12),
        ];

        const totals = [
            rows[0].reduce((total, num) => total + num, 0),
            rows[1].reduce((total, num) => total + num, 0),
            rows[2].reduce((total, num) => total + num, 0),
        ]

        const headers = getMonthHeaders();
        return (
            <div style={{ "marginTop": "4px" }}>
                <Space size={0} justifyContent="stretch" >
                    <Label grow double style={{ "textAlign": "left" }} width={80}><a onClick={() => kbdEvent(KBD.SLASH)}><small>show months</small></a></Label>
                    {headers.map((month, i) => (
                        <div style={{ "display": "flex", "flexGrow": "1" }} key={month}><Label grow style={{ "paddingRight": "2px" }} width={40}><span>{month}&nbsp;</span></Label></div>
                    ))}
                    <Label className="text-light" style={{ "background": "none", "fontSize": "14px", "textAlgin": "right" }} width={54} ><Label style={{ "textAlign": "right", "fontWeight": 700 }}>Ttl</Label></Label>
                </Space>
                {rows.map((row, rowIndex) => (
                    <Space key={rowIndex} size={0} justifyContent="stretch" >
                        <Cell className="text-light" style={{ background: "none", fontSize: "14px", textAlign: "left" }} width={90} >
                            <nobr>Sold {dayjs().add(-rowIndex - 1, "years").format("YY")} / {dayjs().add(-rowIndex, "years").format("YY")}</nobr>
                        </Cell>
                        {row.map((value, colIndex) => (
                            <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_1")} cell double width={39} value={(value) ? value : ""} />
                        ))}

                        <Input grow right className={"text bold"} maxLength={4} {...editProps("sold_1")} cell double width={39} value={(totals[rowIndex]) ? totals[rowIndex] : ""} />


                    </Space>
                ))}
            </div>
        )
    }



    const weekLabels = (_start = dayjs(), _weeks = 14) => {
        const base = dayjs(_start);
        const result = [];
        for (let i = 0; i < _weeks; i++) {
            const d = base.add(-i, "week");
            const monthLetter = d.format("MMM")[0].toUpperCase(); // <-- no month mapping
            const day = d.format("DD");

            result.push(`${monthLetter}${day}`);
        }
        return result.reverse();
    }

    const dailyLabels = (_start = dayjs(), _weeks = 14) => {
        const base = dayjs(_start);
        const result = [];
        for (let i = 0; i < _weeks; i++) {
            const d = base.add(-i, "day");
            const day = d.format("ddd");
            result.push(`${day}`);
        }
        return result.reverse();
    }


    const drawGrid = () => {

        if (!props.gridType?.current && !monthly_sold) {
            return;
        }

        let _arr = [];
        let _received = (grid_info?.received) ? grid_info?.received : Array(14).fill(0);
        let _available_onhand = (grid_info?.available_onhand) ? grid_info?.available_onhand : Array(14).fill(0);
        let _sold = (grid_info?.sold) ? grid_info?.sold : Array(14).fill(0);

        if (props?.gridType?.current === "monthly") {
            return drawMonthly();
        }

        if (props?.gridType?.current === "weekly") {
            _arr = weekLabels();
        }

        if (props?.gridType?.current === "daily") {
            _arr = dailyLabels();
        }


        return (

            <div style={{ "backgroundColor": "transparent" }}>
                <div className="shim" style={{ "height": "4px" }} />
                <Space grow size={0} justifyContent="stretch">
                    <Label className="text-light" style={{ "background": "none", "fontSize": "14px" }} width={46} ><Label width={46}><nobr><a onClick={() => kbdEvent(KBD.SLASH)}><small>{(props?.gridInfo?.current === "weekly") ? "show days" : "show years"}</small></a></nobr></Label></Label>

                    {_arr.map((item, index) => {
                        return (<div style={{ "display": "flex", "flexGrow": "1" }} key={index}><Label grow width={40}><span style={{ "color": "var(--text-light)" }}>{item}</span></Label></div>)
                    })}
                    <Label className="text-light" style={{ "background": "none", "fontSize": "14px", "textAlgin": "right" }} width={54} ><Label style={{ "textAlign": "right", "fontWeight": 700 }}>Ttl</Label></Label>
                    {/* <Label double width={60}>Wk</Label> */}
                </Space>
                {drawShim()}
                <Space grow size={0} justifyContent="stretch" >
                    <Cell className="text-orange" style={{ "background": "none", "fontSize": "14px" }} width={46} >Rcvd</Cell>
                    {_received.map((item, index) => {
                        return (<Cell className="text-orange" double={(index === 0)} grow style={{ "textAlign": "right" }} border width={39} >{drawNumber(item)}</Cell>)
                    })}
                    <Input grow right className={"text-orange"} style={{ "backgroundColor": "#000", "fontWeight": "700" }} cell double width={40} value={total_received} />
                </Space>

                <Space grow size={0} justifyContent="stretch" >

                    <Cell className="text-light" style={{ "background": "none", "fontSize": "14px" }} width={46} >Sold</Cell>
                    {_sold.map((item, index) => {
                        return (<Cell className="text-light" double={(index === 0)} grow style={{ "textAlign": "right" }} border width={39} >{drawNumber(item)}</Cell>)
                    })}
                    <Input grow right className={(!edit) ? "text-light" : ""} style={{ "backgroundColor": "#000", "fontWeight": "700" }} cell double width={40} value={total_sold} />
                </Space>


                <Space grow size={0} justifyContent="stretch" >
                    <Cell className="text-light" style={{ "background": "none", "fontSize": "14px" }} width={46} >aOH</Cell>
                    {_available_onhand.map((item, index) => {
                        return (<Cell double={(index === 0)} grow style={{ "textAlign": "right" }} border width={39} >{drawNumber(item)}</Cell>)
                    })}
                    <Input grow right className={(!edit) ? "label" : ""} cell double width={40} value={""} />
                </Space>

            </div>

        )

    }


    const drawHistory = () => {




        if (props.gridType?.current || monthly_sold) {
            return <>{drawGrid()}</>;
        }



        return (
            <div style={{ "backgroundColor": "transparent" }}>
                <div className="shim" style={{ "height": "4px" }} />
                <Space grow size={0} justifyContent="stretch">

                    <Label grow double width={46}><Float><Label width={46}><nobr><a onClick={() => kbdEvent(KBD.SLASH)}><small>show weeks</small></a></nobr></Label></Float></Label>
                    {month_labels().map((item, index) => {
                        let color = (stock_data["colour_" + (index + 1)]) ? stock_data["colour_" + (index + 1)] : "9C9C9C";
                        return (<div style={{ "display": "flex", "flexGrow": "1" }} key={index}><Label grow style={{ "paddingRight": "2px" }} width={40}><span style={{ "color": "#" + color }}>{item}&nbsp;</span></Label></div>)
                    })}
                    <Label grow double width={40} style={{ "fontWeight": 700 }}>Ttl</Label>

                </Space>
                {drawShim()}
                {drawReceived()}
                <Space grow size={0} justifyContent="stretch" >
                    <Cell className="text-light" style={{ "background": "none", "fontSize": "14px" }} width={46} >Sold</Cell>

                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_1")} cell double width={39} value={sold_1} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_2")} cell border width={39} value={sold_2} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_3")} cell border width={39} value={sold_3} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_4")} cell border width={39} value={sold_4} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_5")} cell border width={39} value={sold_5} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_6")} cell border width={39} value={sold_6} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_7")} cell border width={39} value={sold_7} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_8")} cell border width={39} value={sold_8} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_9")} cell border width={39} value={sold_9} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_10")} cell border width={39} value={sold_10} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_11")} cell border width={39} value={sold_11} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_12")} cell border width={39} value={sold_12} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_13")} cell border width={39} value={sold_13} />
                    <Input grow right className={(!edit) ? "text-light" : ""} maxLength={4} {...editProps("sold_14")} cell border width={39} value={sold_14} />
                    <Input grow right className={(!edit) ? "text-light" : ""} style={{ "backgroundColor": "#000", "fontWeight": "700" }} cell double width={40} value={total_sold} />

                </Space>
                {drawShim()}
                <Space grow size={0} justifyContent="stretch">


                    <Cell grow className="peer" width={39 + 46}>{(peer_header && <>
                        {peer_header.replace(")", "")} peers &nbsp;
                    </>)}
                        {/* <div style={{"display" : "flex", "justifyContent" : "space-between"}}><span>&nbsp;<small>Wk</small></span><span>{peer_14}</span></div> */}
                    </Cell>
                    <Cell grow className="peer" double width={39} >{peer_1}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_2}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_3}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_4}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_5}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_6}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_7}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_8}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_9}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_10}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_11}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_12}</Cell>
                    <Cell grow className="peer" border width={39} >{peer_13}</Cell>
                    <Cell grow style={{ "fontSize": "14px" }} double className="peer" width={40} >{(peer_14 && <Float style={{ "alignItems": "baseline" }}><span style={{ "fontSize": "10px" }}>&nbsp;Wk</span><span>{peer_14}</span></Float>)}</Cell>

                </Space>
            </div>
        )

    }


    const coverRef = useRef(null);


    const expandImage = () => {
        const returnRoute = window.bm_state.value;
        createModal({
            offset: [0, -80],
            component: <>
                stuff</>, closable: true, callback: (e) => {
                    window.bm_state.value = returnRoute;
                }
        })
    }

    const drawImage = () => {

        // If no main, load secondary, if no secondary load placeholder.
        const primary = `https://bookmanager.com/i/bkmngr_cover/isbn/${primary_code}`;
        const secondary = secondary_code ? `https://bookmanager.com/i/bkmngr_cover/isbn/${secondary_code}` : null;
        const placeholder = "https://bookmanager.com/i/nocover-120.png";

        return (
            <div
                key={primary_code}
                ref={coverRef}
                className="img-contain fade"
                id="cover-div"
                onClick={() => expandImage()}
                style={{
                    height: "255px",
                    backgroundPosition: "center center",
                    backgroundSize: "contain",
                    backgroundImage: `url('${primary}')`,
                }}
            >
                <img
                    src={primary}
                    alt="Cover Image"
                    style={{ visibility: "hidden" }}
                    onError={(e) => {
                        const img = e.currentTarget;
                        if (img.src === primary && secondary) {
                            img.src = secondary;
                            coverRef.current.style.backgroundImage = `url('${secondary}')`;
                            return;
                        }
                        img.src = placeholder;
                        coverRef.current.style.backgroundImage = `url('${placeholder}')`;
                    }}
                />
            </div>
        );
    };

    const tabData = [
        { id: "cover", label: 'Cover', content: drawImage() },
        { id: "about", label: 'About', content: 'This is the content of Tab 2' },
        { id: "author", label: 'Author', content: 'This is the content of Tab 3' },
        { id: "comments", label: 'Comments', content: 'This is the content of Tab 4' },
    ];


    const openCoverImage = (image) => {
        const returnRoute = window.bm_state.value;

        window.bm_state.value = ROUTES.HELPERS.COVER;

        createModal({
            offset: [0, 0],
            mask_close: true,
            align: "center",
            title: "Cover Image",
            closable: true,

            component: (
                <>
                    <div className="shim" />
                    <div className="shim" />

                    <div
                        style={{
                            width: "100%",
                            maxHeight: "calc(100vh - 200px)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "auto",
                        }}
                    >
                        <img
                            src={image}
                            alt="Full-size cover"
                            style={{
                                display: "block",
                                maxWidth: "100%",
                                maxHeight: "calc(100vh - 200px)",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                            }}
                        />
                    </div>
                </>
            ),

            callback: () => {
                window.bm_state.value = returnRoute;
            },
        });
    };


    return (
        <FocusWrap message={(drawMessage() && <Status type="active"><InfoIcon />{drawMessage()}</Status>)} style={{ "height": "auto" }} active={edit}>
            
            <div style={{ "padding": "0px 15px", "height": "auto" }} className={"inventory-card"} onDoubleClick={() => {
                if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
                    switchEdit();
                }
            }}>
                <div>
                    <div className="shim" /><div className="shim" />
                    <Row gap={0} align="flex-start">
                        <Row.Item flexGrow={1} minWidth="740px" maxWidth="100%" height="270px">
                            <div className="shim" />
                            <div style={{ "paddingLeft": "0px" }}>
                                {drawCard()}
                                {/* {JSON.stringify(monthly_sold, null, 2)} */}
                                <Spin loading={props?.gridLoading}>
                                    {drawHistory()}
                                </Spin>
                            </div>
                        </Row.Item>
                        <div style={{ width: "10px", flexShrink: 1 }}></div>
                        <Row.Item minWidth="156px" maxWidth="300px" height="270px">
                            <div className="shim" />
                            {drawStatusCard()}
                        </Row.Item>
                        <div style={{ width: "10px", flexShrink: 1 }}></div>
                        <Row.Item flexGrow={0} width="175px" height="270px">
                            <div className="shim" />
                            {drawExtra()}
                        </Row.Item>
                        <div style={{ width: "10px", flexShrink: 1 }}></div>
                        <Row.Item flexShrink={1} flexGrow={1} width="180px" height="270px" className={edit ? "dim-overlay" : ""}>
                            <CoverImage controller={controller} viewFullImage={viewFullImage} setViewFullImage={setViewFullImage} cover_key={cover_key || ""} primary_code={primary_code} secondary_code={secondary_code} onClick={openCoverImage} />
                        </Row.Item>
                    </Row>


                    {/* <Space style={{ "alignItems": "flex-start" }} size={4}>
                <Card secondary style={{ "width": "100%", "minWidth": "740px", "height": "270px" }}>
                    {drawCard()}
                    {drawHistory()}
                </Card>
                <Card secondary style={{ "width": "100%", "minWidth": "170px", "height": "270px" }}>{drawStatusCard()}</Card>
                <div className={(edit) ? "dim-overlay" : ""}><Tabs style={{ width: "235px" }} height={266} tabData={tabData} /></div>
                <Card secondary style={{ "width": "193px", "height": "270px" }}>{drawExtra()}</Card>
            </Space> */}


                </div>

            </div>
        </FocusWrap>
    )
})